exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home-section .dark-overlay {\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  top: 0;\n  left: 0; }\n\n.home-section {\n  background-attachment: fixed !important;\n  background-repeat: no-repeat !important;\n  background-size: cover !important; }\n\n.home-section {\n  background: url(" + require("./../../../assets/teste_parallax.jpg") + ");\n  min-height: 100vh; }\n  .home-section .dark-overlay {\n    width: 100vw;\n    min-height: 100vh; }\n  .home-section .home-inner {\n    padding-top: 20%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rafaelneves/code/ads/ardaexperience/src/app/pages/header/header.component.scss
// module id = ../../../../../src/app/pages/header/header.component.scss
// module chunks = main